<div class="home-page__container">
    <div class="placeholder__container">
        <i class="fa-regular fa-person-digging fa-2xl"></i>
        <h1>Dashboard Placeholder</h1>
    </div>
</div>
